import React from "react";
import CardBox from "../CardBox";
import { Field, reduxForm, formValueSelector, initialize } from "redux-form";
import IntlMessages from "../../util/IntlMessages";
import { Button } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CircularProgress from "../CircularProgress";
import logo from "assets/images/vibo_vibo-magenta-transparent.png";
import axios from "axios";
import { contactUsAPI } from "../../actions/Auth";
class ContactUs extends React.Component {
  state = {
    loader: false,
    isSuccess: false,
  };
  renderInput = ({
    input,
    placeholder,
    name,
    id,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error, warning },
  }) => (
    <div className={`${colName} col-12`}>
      <div className={`form-group ${classType}`}>
        <label htmlFor={name}>
          <IntlMessages id={labelName} />
          {required ? <span className="text-danger">*</span> : null}
        </label>
        <input
          {...input}
          style={{ height }}
          className={className}
          id={id}
          name={name}
          {...input}
          placeholder={placeholder}
          type={type}
          autoComplete="new-password"
          required={required ? true : false}
        />
        {touched &&
          error && (
            <span className="error-message">
              <IntlMessages id={error} />
            </span>
          )}
      </div>
    </div>
  );
  renderTextArea = ({
    input,
    placeholder,
    name,
    id,
    labelName,
    type,
    required,
    colName,
    meta: { touched, error, warning },
  }) => (
    <div className={`${colName} col-12`}>
      <div className="form-group">
        <label htmlFor={name}>
          <IntlMessages id={labelName} />
          {required ? <span className="text-danger">*</span> : null}
        </label>
        <textarea
          {...input}
          className="form-control form-control-lg"
          placeholder={placeholder}
          rows="6"
          id={id}
          // type={type}
          name="message"
          autoComplete="new-email"
          required={required ? true : false}
        />
        {touched &&
          error && (
            <span className="error-message">
              <IntlMessages id={error} />
            </span>
          )}
      </div>
    </div>
  );

  onSubmit = (formValues) => {
    console.log("FORMVAL", formValues);

    // axios.post('https://formspree.io/admin@vibovibo.com', {
    //   formValues
    // })
    // .then(function (response) {
    //   console.log(response);
    // })
    // .catch(function (error) {
    //   console.log(error);
    // });
    // const { imageFile,gallaryFile } = this.props;
    // this.props.closureOnShowLoader();
    // this.props.businessProfileSave({ ...formValues, imageFile,gallaryFile });
    this.props.contactUsAPI(formValues);
  };
  render() {
    return (
      <div className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="login-content">
          <div className="login-header border-bottom">
            <Link className="app-logo" to="/" title="Jambo">
              <img src={logo} alt="jambo" title="Vibo Vibo" />
            </Link>
          </div>
          <div className="login-form">
            <h2 className="text-center mb-4">Contact us</h2>
            {this.state.isSuccess ? (
              <div style={{ textAlign: "center" }} className="mt-5 mb-5">
                <img src={Img} alt="Success" width="40" className="mb-2" />
                <label className="mb-3">
                  Thank you for signing up. Please check your email for an
                  activation link.
                </label>
                <Link to="/login">Login</Link>
              </div>
            ) : (
              <form
                method="POST"
                action="https://formspree.io/admin@vibovibo.com"
                autoComplete="off"
                // onSubmit={this.props.handleSubmit(this.onSubmit)}
              >
                <fieldset>
                  <Field
                    id="full-name"
                    name="name"
                    component={this.renderInput}
                    placeholder="Your Name"
                    type="text"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    // colName="col-md-6"
                    labelName="vibo.contactUs.name"
                    required
                  />
                  {/* <input type="text" name="name" placeholder="Your name"/> */}

                  <Field
                    id="email-address" 
                    name="_replyto"
                    component={this.renderInput}
                    placeholder="Your Email"
                    type="email"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    // colName="col-md-6"
                    labelName="vibo.contactUs.mail"
                    required
                  />
                  {/* <input type="email" name="email" placeholder="Your email"/> */}

                  <Field
                    id="message"
                    name="message"
                    component={this.renderTextArea}
                    placeholder="Your Message"
                    type="textArea"
                    className="form-control form-control-md"
                    height="35px"
                    classType=""
                    // colName="col-md-6"
                    labelName="vibo.contactUs.message"
                    required
                  />
                  {/* <fieldset>
      <label for="full-name">Name</label>
      <input type="text" name="name" className="form-control form-control-md" id="full-name" placeholder="Your Name" required="" />
      <label for="email-address">Email Address</label>
      <input type="email" name="_replyto" className="form-control form-control-md" id="email-address" placeholder="email@domain.tld" required="" />
      <label for="message">Message</label>
      <textarea rows="5" name="message" className="form-control form-control-md" id="message" placeholder="Your Message" required=""></textarea>
    </fieldset> */}
                  {/* <textarea name="message" placeholder="Your message"></textarea> */}
                  <div className="mt-1 mb-2 text-center">
                    {this.state.loader ? (
                      <CircularProgress />
                    ) : (
                      <Button className="btn btn-vibo2" size="md" type="submit">
                        <IntlMessages id="vibo.contactUs.submit" />
                      </Button>
                    )}
                  </div>
                </fieldset>
              </form>
            )}

            {this.props.showMessage &&
              NotificationManager.success(
                currentAppLocale.messages[this.props.alertMessage],
                this.handleRequestClose()
              )}
          </div>
        </div>
      </div>
    );
  }
}

const validate = (formValues) => {
  console.log("fORMvAL", formValues);

  const errors = {};
  if (!formValues.name) {
    errors.name = "vibo.error.contactUs.name";
  }
  if (!formValues.email) {
    errors.email = "vibo.error.contactUs.mail";
  }
  if (!formValues.message) {
    errors.message = "vibo.error.contactUs.message";
  }
  return errors;
};

ContactUs = reduxForm({
  form: "contactus",
  //
  touchOnChange: true,
  enableReinitialize: true,
  // config: true,
})(ContactUs);

// export default ContactUs;
export default withRouter(
  connect(null, { contactUsAPI }, null, { withRef: true })(ContactUs)
);



// WEBPACK FOOTER //
// ./components/ContactUs/ContactUs.js